export const TRACKER_DRIVER = {
    STACK: 'stack',
    POSTHOG: 'posthog',
    MIXPANEL: 'mixpanel',
    LOCAL: 'local',
} as const;

export type TrackerDriver = Enum<typeof TRACKER_DRIVER>;
